import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import type { SiteContent } from '../content/types';
import { getNavigationLabelByHref } from '../content/loadContent';

export function usePageMeta(content: SiteContent): void {
  const location = useLocation();

  useEffect(() => {
    const routeTitleMap: Record<string, string> = {
      '/': content.navigation.primary.find((item) => item.href === '/')?.label ?? content.brand.shortName,
      '/leistungen': getNavigationLabelByHref(content, '/leistungen'),
      '/team': getNavigationLabelByHref(content, '/team'),
      '/praxis': getNavigationLabelByHref(content, '/praxis'),
      '/bewertungen': getNavigationLabelByHref(content, '/bewertungen'),
      '/faq': getNavigationLabelByHref(content, '/faq'),
      '/kontakt': getNavigationLabelByHref(content, '/kontakt'),
      '/karriere': content.placeholderPages.karriere.title,
      '/downloads': content.placeholderPages.downloads.title,
      '/impressum': content.placeholderPages.legal.title,
      '/datenschutz': content.placeholderPages.legal.title,
    };

    const pageTitle = routeTitleMap[location.pathname] ?? content.seo.siteTitle;
    const finalTitle = content.seo.titleTemplate.includes('%s')
      ? content.seo.titleTemplate.replace('%s', pageTitle)
      : `${pageTitle} | ${content.brand.shortName}`;

    document.title = finalTitle;

    let descriptionTag = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!descriptionTag) {
      descriptionTag = document.createElement('meta');
      descriptionTag.name = 'description';
      document.head.appendChild(descriptionTag);
    }
    descriptionTag.content = content.seo.defaultDescription;

    let keywordsTag = document.querySelector<HTMLMetaElement>('meta[name="keywords"]');
    if (!keywordsTag) {
      keywordsTag = document.createElement('meta');
      keywordsTag.name = 'keywords';
      document.head.appendChild(keywordsTag);
    }
    keywordsTag.content = content.seo.keywords.join(', ');
  }, [content, location.pathname]);
}
